import { Ticket } from "lucide-react";
import { loadImg, iconImg, roundRect, text, drawBackground, drawBrand, drawCta, drawAvatar } from "@/lib/badgeImage";

const L = {
  story: { W: 1080, H: 1920, logoY: 150, cardY: 430, cardH: 620, labelY: 1150, nameY: 1440, avatarY: 1300, ctaY: 1560, ctaH: 250 },
  square: { W: 1080, H: 1080, logoY: 90, cardY: 190, cardH: 400, labelY: 660, nameY: 740, avatarY: null, ctaY: 880, ctaH: 160 },
};

export async function renderScratchWinImage({ prize, user, format }) {
  const P = L[format], { W, H } = P;
  const c = document.createElement("canvas"); c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  await document.fonts?.ready;
  const [icon, avatar] = await Promise.all([iconImg(Ticket, "#B45309"), loadImg(user.picture, true)]);
  drawBackground(ctx, W, H);
  await drawBrand(ctx, W, P.logoY, format === "story" ? 1.2 : 1);
  const x = 120, w = W - 240, y = P.cardY, h = P.cardH;
  ctx.save(); ctx.translate(W / 2, y + h / 2); ctx.rotate(-0.04); ctx.translate(-W / 2, -(y + h / 2));
  ctx.shadowColor = "rgba(180,83,9,0.45)"; ctx.shadowBlur = 70; ctx.shadowOffsetY = 24;
  const g = ctx.createLinearGradient(x, y, x + w, y + h); g.addColorStop(0, "#FDE68A"); g.addColorStop(0.5, "#FEF9C3"); g.addColorStop(1, "#FBCFE8");
  roundRect(ctx, x, y, w, h, 56); ctx.fillStyle = g; ctx.fill(); ctx.shadowColor = "transparent";
  ctx.lineWidth = 16; ctx.strokeStyle = "#FCD34D"; roundRect(ctx, x + 8, y + 8, w - 16, h - 16, 50); ctx.stroke();
  const is = h * 0.16;
  if (icon) ctx.drawImage(icon, W / 2 - is / 2, y + h * 0.1, is, is);
  text(ctx, "GROSSER GEWINN!", W / 2, y + h * 0.38, { size: h * 0.075, weight: 800, font: "Plus Jakarta Sans", color: "#B45309" });
  text(ctx, `+${prize}`, W / 2, y + h * 0.74, { size: h * 0.36, weight: 900, color: "#E11D48" });
  text(ctx, "PUNKTE", W / 2, y + h * 0.88, { size: h * 0.07, weight: 800, color: "#B45309" });
  ctx.restore();
  text(ctx, "beim Rubbellos freigerubbelt 🎟️", W / 2, P.labelY, { size: format === "story" ? 56 : 46, weight: 800, maxW: W - 120, fit: true });
  if (P.avatarY) drawAvatar(ctx, avatar, user.name, W / 2, P.avatarY, 64);
  text(ctx, user.name, W / 2, P.avatarY ? P.nameY : P.nameY, { size: format === "story" ? 50 : 42, weight: 700, maxW: W - 200, color: "rgba(255,255,255,0.95)" });
  await drawCta(ctx, W, P.ctaY, P.ctaH, { code: user.referral_code, title: "Rubbel mit & sammle Punkte für Geschenke" });
  return new Promise((resolve) => c.toBlob((b) => resolve(b), "image/png"));
}
